export const setSuit = (value) => ({ type: 'SET_SUIT', value });
export const showSuit = (value) => ({ type: 'SHOW_SUIT', value });
export const showChosenSuit = (value) => ({ type: 'SHOW_CHOSEN_SUIT', value });
